import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const MagicLinkCallback = loadAsyncComponent(() => import('./Container'), 'page');
